import { put, takeLatest } from 'redux-saga/effects';
import { actionCreator } from './slice';
import { handleSagaError } from '../common';
import { IRegionGroup } from '@/models';
import { api } from '@/api/controllers/api';

export function* saga(): Generator {
	yield takeLatest(actionCreator.INIT_START, onInitStart);
}

function* onInitStart() {
	try {
		const regions: IRegionGroup[] = yield api.regions.getRegions();
		yield put(actionCreator.INIT_COMPLETED(regions));
	} catch (error) {
		yield handleSagaError(error, [actionCreator.INIT_FAILED()]);
	}
}
